import React from "react";
import "./Home.css";
import iphn from "../assets/iphn.png";
import { NavLink } from "react-router-dom";

const Home = () => {
  return (
    <div className="container divstyle">
      <div className="row">
        <div className="col-lg-12 colstyle">
          <h1 className="mystyle">Capture Your Life Story</h1>
          <br />
          <p className="line1">
            Momento is a private journal that stays up to date effortlessly.
            <br />
            Capture and collect moments to explore, relive and share your life
            story.
          </p>
        </div>
      </div>
      <div className="imagestyle">
        <img src={iphn} alt="iphn" className="mobileimage" />
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-6 choice">
          <span style={{ color: "#D07000" }}>
            Editors choice and app of the day
          </span>{" "}
          <br />
          Apple App store
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <button className="btn btn-dark buttonstyle">
            <NavLink exact to="/create_memory">
              <span style={{ fontSize: "1.2rem", marginLeft: "0px" }}>
                Create Memory
              </span>
            </NavLink>
            <br></br>
          </button>
        </div>
        <div className="col-lg-4  col-md-6 col-sm-6 appline">
          <span style={{ color: "#D07000" }}>App of the Year Runner-Up</span>
          <br></br>
          App Store Rewind 2011
        </div>
      </div>
      <hr></hr>
      <div className="row">
        <div className="col-lg-12 colstyle">
          <br />
          <br />
          <h1 className="mystyle"> A Private Place to Remember</h1>
          <br />
          <p className="line1">
            Momento provides a private place to capture and remember the
            meaningful moments in your life<br></br>— experiences, events,
            activities, places you visit and people you meet.
          </p>
        </div>
      </div>
      <br />
      <br />
      <div className="row tourstore">
        <div className="col-lg-2 col-md-4 col-sm-6">
          <i class="fa-solid fa-pencil fa-3x"></i>
          <br></br>
          Notes
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6">
          <i class="fa-solid fa-camera-retro fa-3x"></i>
          <br></br>
          Photos
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 ">
          <i class="fa-solid fa-video fa-3x"></i>
          <br></br>
          Videos
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6">
          <i class="fa-solid fa-location-dot fa-3x"></i>
          <br></br>
          Places
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6">
          <i class="fa-solid fa-person fa-3x"></i>
          <br></br>
          Person
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6">
          <i class="fa-solid fa-bookmark fa-3x"></i>
          <br></br>
          Events
        </div>
      </div>
      <div className="buttonstyle-2">
        <button className=" buttondesign">TAKE A QUICK TOUR</button>
      </div>
      <hr />
      <div className="row">
        <div className="col-lg-12 colstyle">
          <br />
          <br />
          <h1 className="mystyle">Effortlessly Up to Date</h1>
          <br />
          <p className="line1">
            Keeping a journal everyday can be difficult so Momento fills in the
            blanks for you by automatically <br></br>collecting and
            intelligently organising your activity on social networks and apps.
          </p>
        </div>
      </div>
      <br />
      <div className="row appstylestore">
        <div className="col-lg-2 col-md-4 col-6 ">
          <i class="fa-brands fa-facebook fa-3x  fb"></i> <br />
          <span className="fb">Facebook</span>
          <br />
          Posts Media
          <br />
        </div>
        <div className="col-lg-2 col-md-4 col-6">
          <i class="fa-brands fa-twitter fa-3x tweet"></i>
          <br />
          <span className="tweet">Twitter</span>
          <br />
          Tweets
        </div>
        <div className="col-lg-2 col-md-4 col-6">
          <i class="fa-brands fa-instagram  fa-3x insta"></i>
          <br />
          <span className="insta">Instagram</span>
          <br />
          Media
        </div>

        <div className="col-lg-2 col-md-4 col-6">
          <i class="fa-solid fa-locust fa-3x swarm"></i>
          <br />
          <span className="swarm">Swarm</span>
          <br />
          Check-ins
        </div>
        <div className="col-lg-2 col-md-4 col-6">
          <i class="fa-brands fa-flickr fa-3x flickr"></i>
          <br />
          <span className="flickr">Flickr</span>
          <br />
          Photos
        </div>
        <div className="col-lg-2 col-md-4 col-6">
          <i class="fa-brands fa-youtube fa-3x youtube"></i>
          <br />
          <span className="youtube">YouTube</span>
          <br />
          Videos
        </div>
      </div>
      <div className="row rowstyle">
        <div className="col-lg-2 col-md-4 col-6">
          <br />
          <i class="fa-solid fa-m fa-2x m" style={{ paddingTop: "17px" }}></i>
          <br />
          <span className="m">Medium</span>
          <br />
          Stories
        </div>
        <div className="col-lg-2 col-md-4 col-6">
          <br />
          <i class="fa-brands fa-spotify fa-3x spotify"></i>
          <br />
          <span className="spotify">Spotify</span>
          <br />
          Saved Music
        </div>
        <div className="col-lg-2 col-md-4 col-6">
          <br />
          <i class="fa-solid fa-wifi fa-3x web"></i>
          <br />
          <span className="web">Web Feed</span>
          <br />
          RSS Atom
        </div>
        <div className="col-lg-2 col-md-4 col-6">
          <br />
          <i class="fa-brands fa-goodreads fa-3x good"></i>
          <br />
          <span className="good">Goodreads</span>
          <br />
          <span className="goodstyle">Books Reviews</span>
        </div>
      </div>
      <br />
      <br /> <hr />
      <div className="row">
        <div className="col-lg-12 colstyle">
          <br />
          <br />
          <h1 className="mystyle">Essential Features</h1>
          <br />
        </div>
      </div>
      <div className="row essentialfeature">
        <div className="col-lg-4 col-md-4 col-sm-4">
          .Write private notes
          <br />
          .Add multiple photos videos
          <br />
          .Tag people you're with
          <br />
          .Tag places you visit
          <br />
          .Keyword entries with tags
          <br />
          .3D Touch Quick Actions
        </div>
        <div className="col-lg-4 col-md-4 col-sm-4">
          .Day, month & year summaries
          <br />
          .Group moments with events
          <br />
          .Search your memories
          <br />
          .Navigate with a calendar
          <br />
          .Explore people, places & tags
          <br />
          .Create custom reminder
        </div>
        <div className="col-lg-4 col-md-4 col-sm-4">
          .Local & iCloud backup
          <br />
          .Lock with passcode/TouchID
          <br />
          .Share memories
          <br />
          .Import activity from feeds
          <br />
          .Export your data
          <br />
          .URL scheme support
          <br />
        </div>
      </div>
      <div className="buttonstyle-2">
        <button className="buttondesign">VIEW ALL THE FEATURES</button>
      </div>
      <hr />
      <div className="row ">
        <div className="col-lg-12 colstyle">
          <br />
          <br />
          <h1 className="mystyle">Perfectely Suited</h1>
          <br />
        </div>
      </div>
      <div className="row perfectlysuited">
        <div className="col-lg-4 col-md-4 col-sm-4">
          <i class="fa-solid fa-book fa-4x icon"></i>
          <br />
          <span className="stylewords">Personal Journal</span>
          <br></br>
          Capture your daily activities, thoughts and <br></br>experiences.
        </div>
        <div className="col-lg-4 col-md-4 col-sm-4">
          <i class="fa-solid fa-book-atlas fa-4x icon"></i>
          <br />
          <span className="stylewords">Travel Journal</span>
          <br />
          Record your trip, the places you visit and your <br />
          daily experiences.
        </div>
        <div className="col-lg-4 col-md-4 col-sm-4">
          <i class="fa-solid fa-bag-shopping fa-4x icon"></i>
          <br />
          <span className="stylewords">
            Work / Project Journal
            <br />
          </span>
          Track project notes, milestones and meetings <br /> for a record of
          progress.
        </div>
      </div>
      <div className="buttonstyle-2">
        <button className="buttondesign">VIEW MORE EXAMPLES</button>
      </div>
    </div>
  );
};

export default Home;
